var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{directives:[{name:"disabled-icon-focus",rawName:"v-disabled-icon-focus"}],attrs:{"label":_vm.label,"items":_vm.listOfUFs,"clearable":"","dense":"","outlined":"","hint":"Este campo é obrigatório","hide-selected":"","rules":_vm.rules},model:{value:(_vm.ufData),callback:function ($$v) {_vm.ufData=$$v},expression:"ufData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }